import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { firebaseStateReducer } from 'react-redux-firebase'
import { reducer as formReducer } from 'redux-form'
import customers from './customers'

export default combineReducers({
  router: routerReducer,
  firebase: firebaseStateReducer,
  form: formReducer,
  customers
})



// WEBPACK FOOTER //
// ./src/store/modules/reducer.js